module.exports = __webpack_public_path__ + "static/media/projects_thumb_k12_flyers_2x.1ad2d9d1.jpg";